module.exports = __webpack_public_path__ + "static/media/d3ru.95e0d132.pdf";